/*
* @Author: Wang Shuai
* @Date:   2022-04-13 11:06:32
* @Last Modified by:   Wang Shuai
* @Last Modified time: 2022-04-14 16:56:10
*/
// 注册用户页面的 接口集合
import request from '../request.js'

// 获得入驻企业 当前的 标签信息
export const getObjectTags = function (data) {
    return request({
        url: 'operateTagObject/getObjectTags',
        method: 'post',
        data
    })
}

// 保存入驻企业 当前的 标签信息
export const saveObjectTags = function (data) {
    return request({
        url: 'userTenantCenter/saveObjectTags',
        method: 'post',
        data
    })
}

// 用户列表 -- 新接口 --- 叶凡
export const selectUserPage = function (data) {
    return request({
        url: 'users/selectUserPage',
        method: 'post',
        data
    })
}
// 修改账户状态/启用禁用-- 新接口--- 叶凡
export const updateUser = function (data) {
    return request({
        url: 'users/updateUser',
        method: 'post',
        data
    })
}

// 个人用户基础信息 --- 新接口 --- 叶凡
export const getUserDetails = function (data) {
    return request({
        url: 'users/getUserDetails',
        method: 'post',
        data
    })
}

// 个人用户详情tab项信息 --- 新接口 --- 叶凡
export const getUserOthers = function (data) {
    return request({
        url: 'users/getUserOthers',
        method: 'post',
        data
    })
}

// 查询用户手机号变更记录 --- 叶凡
export const getPhoneChanges = function (data) {
    return request({
        url: 'users/getPhoneChanges',
        method: 'post',
        data
    })
}
